<ngx-awesome-uploader  [fileExtensions]="['xlsx']" #uploader [captions]="captions" [adapter]="adapter" (uploadFail)="onUploadFail($event)" (validationError)="onValidationError($event)" (uploadSuccess)="onUploadSuccess($event)" (removeSuccess)="onRemoveSuccess($event)">
</ngx-awesome-uploader>
<hr>
<div class="alert alert-warning"><strong>Importante:</strong> Solo seran subidos aquellos registros que los valores sean validos, son requisitos obligatorios nombre, apellidos y RUT valido.</div>
<button class="btn btn-secondary w-100" (click)="downloadTemplate()">
    <i class="fa-solid fa-download"></i>
    <i class="fa-regular fa-file-excel"></i>
    Descargar Plantilla Excel
  </button>
  